import apiClient from '../../shared/services/apiClient';

/**
 * 云盘管理后台 — /api/admin/disk/*（契约见 docs/disk/SPEC.md §4 Admin）。
 * 返回后端 body；HTTP 错误时抛出 {success:false, error, status, ...body}。
 */
const BASE = '/api/admin/disk';

const call = async (p) => {
    try {
        const res = await p;
        return res.data;
    } catch (e) {
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { ...body, success: false, status: e?.response?.status, error: body.error || body.message || e?.message };
    }
};
const get = (url, params) => call(apiClient.get(`${BASE}${url}`, { params }));
const patch = (url, data) => call(apiClient.patch(`${BASE}${url}`, data || {}));
const post = (url, data) => call(apiClient.post(`${BASE}${url}`, data || {}));
const put = (url, data) => call(apiClient.put(`${BASE}${url}`, data || {}));

const diskAdminService = {
    stats: () => get('/stats'),
    traffic: (days = 30) => get('/traffic', { days }),
    listAccounts: (params) => get('/accounts', params),
    setAccountStatus: (id, status) => patch(`/accounts/${id}`, { status }),
    setAccountFreeStorage: (id, gb) => patch(`/accounts/${id}`, { admin_storage_gb: gb }),
    listOrgs: (params) => get('/orgs', params),
    setOrgStatus: (id, status) => patch(`/orgs/${id}`, { status }),
    listShares: (params) => get('/shares', params),
    revokeShare: (id) => post(`/shares/${id}/revoke`),
    listLinks: (params) => get('/links', params),
    setLinkEnabled: (id, enabled) => patch(`/links/${id}`, { enabled }),
    getSettings: () => get('/settings'),
    saveSettings: (data) => put('/settings', data),
};

export default diskAdminService;
